// TODO: Delete those

export enum CategoryGroupEnum {
  INCOME = 'income',
  TRANSPORTATION = 'transportation',
  HOME = 'home',
  UTILITIES = 'utilities_living',
  HEALTH = 'health',
  ENTERTAINMENT = 'entertainment',
  OTHER = 'other',
  DONATION = 'donation',
}

export enum UtilityExpensesEnum {
  HEATING = 'heating',
  ELECTRICITY = 'electricity',
  WATER = 'water',
  INTERNET = 'internet',
  GROCERIES = 'groceries',
  PETS = 'pets',
  KIDS = 'kids',
  SCHOOL = 'school',
}

export enum TransportEnum {
  OWN_CAR = 'own_car',
  PUBLIC_TRANSPORT = 'public_transport',
}

export enum HealthEnum {
  DENTAL = 'dental',
  VISION = 'vision',
  OTHER_MEDICAL = 'other_medical',
  GYM = 'gym',
  SPORTS = 'sports',
}

export enum EntertainmentEnum {
  STREAMING = 'streaming',
  EATING_OUT = 'eating_out',
  MUSIC = 'music',
  BOOKS = 'books',
  TRAVEL = 'travel',
}

export interface IDefaultCategoryGroups {
  name: CategoryGroupEnum;
  items?: {
    name: UtilityExpensesEnum | HealthEnum | EntertainmentEnum | TransportEnum | string;
  }[];
}

const defaultCategoryGroups: IDefaultCategoryGroups[] = [
  { name: CategoryGroupEnum.INCOME },
  { name: CategoryGroupEnum.TRANSPORTATION, items: Object.values(TransportEnum).map(ex => ({ name: ex })) },
  { name: CategoryGroupEnum.HOME },
  { name: CategoryGroupEnum.UTILITIES, items: Object.values(UtilityExpensesEnum).map(ex => ({ name: ex })) },
  { name: CategoryGroupEnum.HEALTH, items: Object.values(HealthEnum).map(h => ({ name: h })) },
  { name: CategoryGroupEnum.ENTERTAINMENT, items: Object.values(EntertainmentEnum).map(ent => ({ name: ent })) },
  { name: CategoryGroupEnum.OTHER },
  { name: CategoryGroupEnum.DONATION },
];

export default defaultCategoryGroups
